<template>
    <div>
        <div
            class="newCategoriesSlider__skeleton"
            v-if="getIsLoadingCategories"
        >
            <div
                class="newCategoriesSlider__skeleton__item"
                v-for="i in 10"
            ></div>
        </div>
        <div class="newCategoriesSlider" v-if="!getIsLoadingCategories">
            <div class="newCategoriesSlider__wrapper">
                <div
                    class="swiper-button swiper-button-prev swiper-button-prev-categoty"
                    ref="caregoryToPrev"
                >
                    <div class="swiper-button--item">
                        <IArr />
                    </div>
                </div>
                <div
                    class="mainChanelContent__timeShift_controls_swiper"
                    v-if="activeSlideIndex !== null"
                >
                    <swiper
                        :slidesPerView="'auto'"
                        :initialSlide="activeSlideIndex"
                        :mousewheel="true"
                        :free-mode="true"
                        :modules="modules"
                        :navigation="{
                            prevEl: caregoryToPrev,
                            nextEl: caregoryToNext,
                        }"
                        :spaceBetween="10"
                        @swiper="swiper"
                        ref="mySwiper"
                        class="mySwiper"
                    >
                        <swiper-slide
                            @click="slideToSlide(0)"
                            class="newCategoriesSlider__item"
                        >
                            <ElButton
                                size="small"
                                :type="
                                    selectedCategory == 'all'
                                        ? 'default'
                                        : 'grey'
                                "
                                @click="() => filterByCategory('all')"
                            >
                                {{ $t("message.all") }}
                            </ElButton>
                        </swiper-slide>
                        <swiper-slide
                            class="newCategoriesSlider__item"
                            @click="slideToSlide(1)"
                            v-if="isLoggedIn"
                        >
                            <ElButton
                                size="small"
                                :type="
                                    selectedCategory == 'favoritesInner'
                                        ? 'default'
                                        : 'grey'
                                "
                                @click="
                                    () => filterByFavorites('favoritesInner')
                                "
                            >
                                {{ $t("message.favouriteTv") }}
                            </ElButton>
                        </swiper-slide>
                        <swiper-slide
                            class="newCategoriesSlider__item"
                            v-for="(category, index) in getCategoryList"
                            :key="category.id"
                            @click="slideToSlide(index + 2)"
                        >
                            <ElButton
                                size="small"
                                :type="
                                    category.id == selectedCategory
                                        ? 'default'
                                        : 'grey'
                                "
                                @click="() => filterByCategory(category.id)"
                            >
                                {{ category.name }}
                            </ElButton>
                        </swiper-slide>
                    </swiper>
                </div>

                <div
                    class="swiper-button swiper-button-next swiper-button-next-categoty"
                    ref="caregoryToNext"
                >
                    <div class="swiper-button--item">
                        <IArr />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref } from "vue";
import ElButton from "../ElButton/index.vue";
import IBannerSwiper from "../../components/Icons/IBannerSwiper.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { mapGetters } from "vuex";
import IArr from "./icons/iArr.vue";

import { Navigation, Mousewheel, FreeMode } from "swiper/modules";
import "swiper/css";
export default {
    name: "NewCategoriesSlider",
    components: {
        IBannerSwiper,
        Swiper,
        SwiperSlide,
        ElButton,
        IArr,
    },
    props: ["isLoggedIn"],
    data() {
        return {
            selectedCategory: null,
            activeSlideIndex: null,
            scrollleft: null,
            text: "",
            swiperInstance: null,
        };
    },
    computed: {
        ...mapGetters([
            "getCategoryList",
            "getSelectedCategory",
            "getIsLoadingCategories",
        ]),
        locale() {
            return this.$i18n.locale;
        },
        currentLang() {
            return this.$i18n.locale === "ru" ? "" : "uz";
        },
    },
    watch: {
        locale() {
            this.loadCategories();
        },
        getSelectedCategory(value) {
            this.selectedCategory = value;
            if (value === "all") {
                this.activeSlideIndex = 0;
                this.swiperInstance.slideTo(0, 1000, false);
            } else if (value === "favoritesInner") {
                this.activeSlideIndex = 1;
                this.swiperInstance.slideTo(1, 1000, false);
            }
        },
    },
    setup() {
        const caregoryToPrev = ref(null);
        const caregoryToNext = ref(null);
        return {
            modules: [Navigation, Mousewheel, FreeMode],
            caregoryToPrev,
            caregoryToNext,
        };
    },
    created() {
        this.loadCategories();
    },
    methods: {
        slideToSlide(index) {
            this.swiperInstance.slideTo(index - 1, 1000, false);
        },
        swiper(swiper) {
            this.swiperInstance = swiper;
        },
        loadCategories() {
            if (this.selectedCategory) {
                if (this.text) {
                    this.activeSlideIndex = 0;
                    this.swiperInstance.slideTo(0, 1000, false);
                    this.search(this.text);
                    return;
                }
                if (this.selectedCategory === "favoritesInner") {
                    this.filterByFavorites();
                } else {
                    this.filterByCategory(this.selectedCategory);
                }
            } else {
                this.$store.dispatch("fetchCategories", {
                    lang: this.currentLang,
                });
                this.activeSlideIndex = 0;
                this.selectedCategory = "all";
            }
            if (this.$store.getters.getSelectedCategory) {
                this.selectedCategory = this.$store.getters.getSelectedCategory;
                const index = this.$store.getters.getCategoryList.findIndex(
                    (item) => item.id === this.selectedCategory
                );
                this.activeSlideIndex = index;
            }
        },
        filterByCategory(id) {
            if (id === "all") {
                this.selectedCategory = "all";
            } else if (id === "favoritesInner") {
                this.selectedCategory = "favoritesInner";
                this.text = null;
            } else {
                this.selectedCategory = id;
                this.text = null;
            }
            this.$store.commit("SET_ACTIVE_CATEGORY", this.selectedCategory);
            this.$store.commit("SET_FILTERED_CHANELS", id);
        },
        filterByFavorites() {
            this.selectedCategory = "favoritesInner";
            this.$store.commit("SET_ACTIVE_CATEGORY", this.selectedCategory);
            this.$store.commit("SET_FAVORITED_CHANELS");
            this.text = null;
        },
    },
};
</script>

<style lang="scss">
@import "./styles/categories.scss";
</style>
